import React from "react";
import '../Common.scss';
import defaultImage from '../../../assets/default.png';
import styles from './plumbingElevation.module.scss';
export default class PlumbingElectricals extends React.Component<any, any>{

    render() {
        const { pageDetails } = this.props;
        //const images = pageDetails['images'][0];
        const { plumbingData, elevationImage } = pageDetails || {};
        return (
            <React.Fragment>
                <div className="page-image-container">
                    <div className="page-heading">{pageDetails?.name}</div>
                    <div className="image-section-container">
                        <img crossOrigin="anonymous" src={elevationImage ? `${elevationImage}?ver=${new Date().getTime()}` :defaultImage} alt="" className="image-view" />
                    </div>
                </div>
                <div className={styles["tables-alignment"]} style={{marginTop: "15px", marginLeft: "10px"}}>
                    <div className={styles.Table}>
                        {/* <div class="Title">
                            <p>This is a Table</p>
                        </div> */}
                        <div className={styles.Heading}>
                            <div className={styles.Cell}>
                                <p><span className={styles['table-head']}>No</span></p>
                            </div>
                            <div className={styles.Cell}>
                                <p><span className={styles['table-head']}>DESCRIPTION</span></p>
                            </div>
                        </div>
                        {
                            plumbingData && plumbingData.map(ele=>{
                                return(
                                    <div className={styles.Row}>
                                        <div className={styles.Cell}>
                                            <p><span className={styles['table-content']}>{ele["caption"]?.toString()?.toUpperCase()}</span></p>
                                        </div>
                                        <div className={styles.Cell}>
                                            <p><span className={styles['table-content']}>{ele["description"]?.toString()?.toUpperCase()}</span></p>
                                        </div>
                                    </div>
                                );
                            })
                        }
                    </div>
                </div>
            </React.Fragment>

        )
    }

}